import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';

import { sendZapHook } from '../lib/zaps';

const ContactMessageSchema = z.object({
  email: z.string().email(),
  message: z.string(),
});

export const sendContactMessage = createServerFn({
  method: 'POST',
})
  .validator(
    (data: {
      email: string;
      message: string;
    }) => ContactMessageSchema.parse(data)
  )
  .handler(async (ctx) => {
    await sendZapHook({
      type: 'contact-form',
      data: {
        email: ctx.data.email,
        message: ctx.data.message,
      },
    });

    return {
      message: 'Contact form submitted',
    };
  });
